import * as token from './token';
import { ensureValidToken } from './refresh';

class SessionMonitor {
  constructor() {
    this.intervalId = null;
    this.isMonitoring = false;
    this.CHECK_INTERVAL = 300000; // 5 minutos (ajustado para tokens de 15 min)
  }

  start() {
    if (this.isMonitoring) return;
    
    console.log('🔍 Starting session monitor...');
    this.isMonitoring = true;
    
    this.intervalId = setInterval(() => {
      this.checkSession();
    }, this.CHECK_INTERVAL);

    // Verificar também quando a aba ganha foco (usuário volta)
    window.addEventListener('focus', this.handleWindowFocus.bind(this));
    
    // Verificar quando usuário retorna de inatividade
    document.addEventListener('visibilitychange', this.handleVisibilityChange.bind(this));
  }

  stop() {
    if (!this.isMonitoring) return;
    
    console.log('⏹️ Stopping session monitor...');
    this.isMonitoring = false;
    
    if (this.intervalId) {
      clearInterval(this.intervalId);
      this.intervalId = null;
    }

    window.removeEventListener('focus', this.handleWindowFocus.bind(this));
    document.removeEventListener('visibilitychange', this.handleVisibilityChange.bind(this));
  }

  async checkSession() {
    try {
      // Só verificar se temos um token
      const currentToken = token.get();
      if (!currentToken) {
        this.redirectToLogin('No token found');
        return;
      }

      // Se token expirou, tentar refresh
      if (token.isExpired()) {
        console.log('⏰ Token expired during monitoring, attempting refresh...');
        await ensureValidToken();
        console.log('✅ Token refreshed successfully during monitoring');
      }
    } catch (error) {
      console.error('❌ Session check failed:', error);
      this.redirectToLogin('Session validation failed');
    }
  }

  handleWindowFocus() {
    // Quando usuário volta para a aba, verificar sessão imediatamente
    console.log('👀 Window focused, checking session...');
    this.checkSession();
  }

  handleVisibilityChange() {
    if (!document.hidden) {
      // Página ficou visível, verificar sessão
      console.log('👁️ Page became visible, checking session...');
      this.checkSession();
    }
  }

  redirectToLogin(reason) {
    console.log(`🔄 Redirecting to login: ${reason}`);
    
    // Limpar tokens
    token.destroy();
    
    // Parar monitoramento
    this.stop();
    
    // Redirecionar se não estiver já na página de login
    if (window.location.pathname !== '/login') {
      window.location.href = '/login';
    }
  }
}

// Exportar instância singleton
export default new SessionMonitor();